const STATIC_MARITAL_STATUS_OPTIONS = Object.freeze([
  { id: "19", name: "single", display_label: "single" },
  { id: "20", name: "divorced", display_label: "divorced" },
  { id: "21", name: "widowed", display_label: "widowed" },
  { id: "22", name: "separated", display_label: "separated" },
]);

export function getStaticMaritalStatusOptions() {
  return STATIC_MARITAL_STATUS_OPTIONS.map((option) => ({ ...option }));
}

export default STATIC_MARITAL_STATUS_OPTIONS;
